import { QueryParamsSchema } from '@onramp/shared/queryParams.schema';
import { dedupe } from '@onramp/utils/dedupe';

import { BaseBuyWidgetSchema } from '../shared/appParams.schema';

export const ALLOWED_QUERY_PARAM_KEYS: readonly string[] = dedupe([
  ...Object.keys(QueryParamsSchema.shape),
  ...Object.keys(BaseBuyWidgetSchema.shape),
]);
